<template>
  <div class="main supervision-main">
    <div class="list-content">
      <catalogue-search-bar
        :search-params="searchParams"
        :store-id="storeId"
        @changeSearchParams="changeSearchParams"
        @search="search"
      />
      <catalogue-list :data="list" :pageNo="pageNo" :pageSize="pageSize" />
      <pagination
        @handlePage="handlePage"
        v-if="list && list.length"
        :total="total"
        :current-page="pageNo"
        :page-size="pageSize"
      />
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import catalogueSearchBar from './components/catalogueSearchBar';
import catalogueList from './components/catalogueList';
import pagination from './components/pagination';

export default {
  name: 'orderList',
  components: {
    catalogueSearchBar,
    catalogueList,
    pagination
  },
  data() {
    return {
      searchParams: {
        drugName: '',
        drugStatus: '1'
      },
      list: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tabs: 'today',
      statics: {}
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { pageSize } = this;
      this.fetchList({ drugName: '', drugStatus: '1', pageNo: 1, pageSize });
    },
    handlePage(pageNo) {
      const { searchParams, pageSize } = this;

      this.fetchList({ ...searchParams, pageNo, pageSize });
    },

    search() {
      const { searchParams, pageSize } = this;

      this.fetchList({ ...searchParams, pageNo: 1, pageSize });
    },
    changeSearchParams({ key, value }) {
      this.searchParams[key] = value;
    },
    fetchList(params) {
      const { storeId } = this;
      const { drugStatus, ...rest } = params;
      return Fetch.getSupervisionCatalogueList({
        ...rest,
        drugStatus: drugStatus || null,
        storeId
      }).then(res => {
        const { pageNo, totalCount, data } = res;
        this.pageNo = pageNo;
        this.total = totalCount;
        this.list = data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  height: 100%;
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
}
</style>
